module.exports = __webpack_public_path__ + "img/logo6.7e32641e.png";